<template>
	<b-modal ref="modal" title="Change your email" :busy="loading>0">
		<b-form @submit.stop.prevent="changeEmail()" id="changePasswordForm">
			<b-form-group label="Current email">
				<b-form-input type="email" v-model="currentEmail" placeholder="Current email"></b-form-input>
			</b-form-group>
			<b-form-group label="New email">
				<b-form-input type="email" v-model="email" placeholder="New email" required></b-form-input>
			</b-form-group>
		</b-form>
		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<template #modal-footer="{ ok, cancel }">
			<div class="w-100">
				<div class="float-right">
					<b-spinner v-show="loading>0" small label="Spinning" class="mr-3"></b-spinner>
					<b-button variant="primary" type="submit" form="changePasswordForm" class="mr-2">Update</b-button>
					<b-button size="sm" @click="cancel()">Cancel</b-button>
				</div>
			</div>
		</template>
	</b-modal>
</template>

<script>
export default {
	data: () => ({
		currentEmail: '',
		email: '',
		loading: 0,
		error: null,
	}),
	methods: {
		show() {
			this.$refs.modal.show();
		},
		async changeEmail() {
			this.loading++;
			try {
				await this.$api.post('changeEmailAddress', {
					currentEmail: this.currentEmail,
					email: this.email,
				});
				this.$refs.modal.hide();
				this.$bvToast.toast('Successfully changed email address. Please check your inbox to confirm the new address.', {
					title: 'Success',
					variant: 'success',
					solid: true
				});
				this.$emit('saved');
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
	},
}
</script>
